import {Layout, Menu, MenuProps} from 'antd';
import {Navigate, NavLink, Route, Routes, useLocation} from 'react-router-dom';
import BatteryCatagories from './batteryCategory/BatteryCategory';
import Batteries from './batteries/Batteries';
import {useAppSelector} from '../../../common/hooks';
type MenuItem = Required<MenuProps>['items'][number];

const {Header, Content} = Layout;

const Main = () => {
  const userPermission = useAppSelector((state) => state.config.config.permissions);
  const items: MenuItem[] = [
    userPermission.show_battery
      ? {label: <NavLink to={'/setup/battery/batteries'}>Batteries</NavLink>, key: 'batteries'}
      : null,
    userPermission.show_batterycategory
      ? {label: <NavLink to={'/setup/battery/categories'}>Catagories</NavLink>, key: 'categories'}
      : null,
  ];

  return (
    <Layout style={{height: '100%', backgroundColor: '#fff'}}>
      <Header
        style={{
          backgroundColor: '#fff',
          alignItems: 'center',
          paddingInline: '00px',
          height: '48px',
          marginBottom: '10px',
          borderBottom: ' 1px solid #00000022',
        }}
      >
        <Menu
          mode='horizontal'
          theme='light'
          selectedKeys={[useLocation().pathname.split('/')[3]]}
          style={{
            backgroundColor: 'transparent',
            border: '0px',
            lineHeight: '40px',
          }}
          items={items}
        />
      </Header>
      <Content style={{padding: '0px 30px 0px'}}>
        {/* <h1>asdad</h1> */}
        <Routes>
          {userPermission.show_batterycategory && (
            <Route path='/categories' element={<BatteryCatagories />} />
          )}
          <Route path='/' element={userPermission.show_battery && <Navigate to={'batteries'} />} />
          {userPermission.show_battery && <Route path='/batteries' element={<Batteries />} />}
          <Route path='/*' element={<Navigate to={'/404/'} />} />
        </Routes>
      </Content>
    </Layout>
  );
};

export default Main;
